/* src/app/components/companies-components/companies-new-company-creation-card/companies-new-company-creation-card.component.scss */
.info-card footer > p {
  margin: 3rem 0 0 0;
  opacity: 0.75;
}
.info-card footer > div {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.info-card footer > div > span {
  font-size: 1.2rem;
  color: #5e6e82;
  flex-grow: 1;
  text-align: center;
  margin: 3rem 0 3rem 0;
}
.info-card footer > div:last-of-type {
  justify-content: flex-end;
}
.info-card footer h6 {
  color: red;
  margin: 1rem;
}
.info-card footer > h6 {
  font-size: 1.8;
  padding: 1rem;
  background-color: rgba(255, 0, 0, 0.15);
}
.info-card footer > figure {
  display: flex;
  flex-direction: column;
  height: 400px;
  margin: 1rem 0;
  border: 1px solid #5e6e82;
}
.info-card footer > figure > div {
  width: 100%;
  height: 100%;
}
.info-card footer > ul {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #5e6e82;
}
/*# sourceMappingURL=companies-new-company-creation-card.component.css.map */
